import { render } from "./InterventionPage.vue?vue&type=template&id=94549596&scoped=true&ts=true"
import script from "./InterventionPage.vue?vue&type=script&lang=ts"
export * from "./InterventionPage.vue?vue&type=script&lang=ts"

import "./InterventionPage.vue?vue&type=style&index=0&id=94549596&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94549596"]])

export default __exports__